const normalizeText = (value) => String(value || '').trim().toLowerCase();
const sameId = (left, right) => String(left ?? '') === String(right ?? '');

export const hasActiveSubscription = (trainer) =>
  Boolean(trainer.latest_purchase_plan) && Number(trainer.coins) > 0;

export const trainerMatchesFilters = (trainer, filters, excludedFilter = null) => {
  if (excludedFilter !== 'subscription' && filters.subscription) {
    const isActive = hasActiveSubscription(trainer);
    if ((filters.subscription === 'active') !== isActive) {
      return false;
    }
  }

  if (excludedFilter !== 'onlineStatus' && filters.onlineStatus) {
    const isOnline = Boolean(trainer.is_online);
    if ((filters.onlineStatus === 'online') !== isOnline) {
      return false;
    }
  }

  if (excludedFilter !== 'serviceType' && filters.serviceType &&
      normalizeText(trainer.service_type) !== normalizeText(filters.serviceType)) {
    return false;
  }

  if (excludedFilter !== 'state' && filters.state &&
      !sameId(trainer.state_id, filters.state)) {
    return false;
  }

  if (excludedFilter !== 'district' && filters.district &&
      !sameId(trainer.district_id, filters.district)) {
    return false;
  }

  if (excludedFilter !== 'category' && filters.category &&
      !sameId(trainer.category_id, filters.category)) {
    return false;
  }

  if (excludedFilter !== 'subcategory' && filters.subcategory) {
    const subcategories = Array.isArray(trainer.subcategories) ? trainer.subcategories : [];
    if (!subcategories.some((subcategory) => sameId(subcategory.id, filters.subcategory))) {
      return false;
    }
  }

  if (excludedFilter !== 'gender' && filters.gender &&
      normalizeText(trainer.gender) !== normalizeText(filters.gender)) {
    return false;
  }

  if (excludedFilter !== 'email' && filters.email &&
      !normalizeText(trainer.email).includes(normalizeText(filters.email))) {
    return false;
  }

  if (excludedFilter !== 'phone' && filters.phone &&
      !String(trainer.phone || '').trim().includes(String(filters.phone || '').trim())) {
    return false;
  }

  return true;
};

export const countTrainerOptions = (trainers, filters, filterName, options, getValue) => {
  const counts = new Map();
  counts.set(
    '',
    trainers.filter((trainer) => trainerMatchesFilters(trainer, filters, filterName)).length
  );
  options.forEach((option) => {
    const value = getValue(option);
    counts.set(
      String(value),
      trainers.filter((trainer) =>
        trainerMatchesFilters(trainer, filters, filterName) &&
        trainerMatchesFilters(trainer, { ...filters, [filterName]: value })
      ).length
    );
  });
  return counts;
};
